import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";


const getEcommerceCategories = () => {
    return Api(SUPPLIER_ENDPOINTS.CATEGORY.GET_ALL, null, requestType.GET);
};

const getEcommerceSubCategories = (params) => {
    const ENDPOINT = SUPPLIER_ENDPOINTS.SUB_CATEGORY.GET_ALL;

    const queryParams = new URLSearchParams();
    if (params.categoryId) queryParams.append("categoryId", params.categoryId);

    const finalUrl = queryParams.toString() ?
        `${ENDPOINT}?${queryParams.toString()}` :
        `${ENDPOINT}`;

    return Api(finalUrl, null, requestType.GET);
};

const getEcommerceSubSubCategories = (params) => {
    const ENDPOINT = SUPPLIER_ENDPOINTS.SUB_SUB_CATEGORY.GET_ALL;

    const queryParams = new URLSearchParams();
    if (params.categoryId) queryParams.append("categoryId", params.categoryId);
    if (params.subCategoryId) queryParams.append("subCategoryId", params.subCategoryId);

    const finalUrl = queryParams.toString() ?
        `${ENDPOINT}?${queryParams.toString()}` :
        `${ENDPOINT}`;

    return Api(finalUrl, null, requestType.GET);
};

const getAllEcommerceTags = (params) => {

    const ENDPOINT = SUPPLIER_ENDPOINTS.ECOMMERCE_TAGS.GET_ALL;
    const queryParams = new URLSearchParams();
    if (params.name) queryParams.append("name", params.name);
    if (params.status) queryParams.append("status", params.status);
    if (params.solutionType) queryParams.append("solutionType", params.solutionType);
    if (params.appliesTo) queryParams.append("appliesTo", params.appliesTo);

    const finalUrl = queryParams.toString()
        ? `${ENDPOINT}?${queryParams.toString()}`
        : `${ENDPOINT}`;

    return Api(finalUrl, null, requestType.GET);
};

export {
    getEcommerceCategories,
    getEcommerceSubCategories,
    getEcommerceSubSubCategories,
    getAllEcommerceTags
};

